import React from "react";
import { Container, Row, Col, Table, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faDownload, faFileInvoice } from "@fortawesome/free-solid-svg-icons";

const iconStyle = { maxWidth: "50px", maxHeight: "20px" };
const imageStyle = { maxWidth: "30px", maxHeight: "50px" };

const Invoice = () => {
  return (
    <Container fluid className="p-4 bg-white rounded shadow-sm animate__animated animate__fadeIn" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <Row className="mb-4 align-items-center">
        <Col xs={12} md={6} className="mb-2 mb-md-0">
          <h4 className="fw-bold text-primary" style={{ fontSize: "1.75rem" }}>INVOICE</h4>
        </Col>
        <Col xs={12} md={6} className="text-md-end">
          <Image
            src="https://constacloud.com/commercium/static/images/logo/commercium-logo-dark.png"
            alt="Commercium"
            fluid
            style={{ maxWidth: "100px", height: "auto" }}
            className="mb-1"
          />
          <div className="text-muted" style={{ fontSize: "0.9rem" }}>[Address Section 1]</div>
          <div className="text-muted" style={{ fontSize: "0.9rem" }}>[Address Section 2]</div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <p className="mb-1" style={{ fontSize: "1rem" }}>
            Dear <strong>[Customer Name]</strong> (<a href="mailto:robert@benko.com">customer@invoice.com</a>),
          </p>
          <p className="text-muted" style={{ fontSize: "0.95rem" }}>Here are your order details. We thank you for your purchase.</p>
        </Col>
      </Row>

      <Row className="mb-4 text-center text-md-start" style={{ fontSize: "0.95rem" }}>
        <Col xs={6} md={3}><strong>Order ID</strong><br />#14534</Col>
        <Col xs={6} md={3}><strong>Date</strong><br />27 May, 2025</Col>
        <Col xs={6} md={3}><strong>Invoice ID</strong><br />#INV-000414</Col>
        <Col xs={6} md={3}><strong>Shipment ID</strong><br />#SHP-0025410</Col>
      </Row>

      <Row className="mb-4">
        <Col md={6} className="mb-3 mb-md-0">
          <strong>Billing Address</strong><br />
          <small className="text-muted" style={{ fontSize: "0.9rem" }}>
            [Address]
          </small>
        </Col>
        <Col md={6}>
          <strong>Shipping Address</strong><br />
          <small className="text-muted" style={{ fontSize: "0.9rem" }}>
            [Address]
          </small>
        </Col>
      </Row>

      <Table responsive bordered hover className="bg-white text-center" style={{ fontSize: "0.95rem" }}>
        <thead className="table-light">
          <tr>
            <th>Products</th>
            <th>SKU</th>
            <th>QTY</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-start">
              <Image
                src="https://tse3.mm.bing.net/th/id/OIP.fqPPz4wieHpVF4SF0Q7pZAHaHa?cb=iwp2&rs=1&pid=ImgDetMain"
                alt="Product 1"
                roundedCircle
                className="me-2"
                style={imageStyle}
              />
              Product 1<br />
              <small className="text-muted">Delivery Date: 27/05/2025</small>
            </td>
            <td>03748005</td>
            <td>2</td>
            <td>$240.00</td>
          </tr>
          <tr>
            <td className="text-start">
              <Image
                src="https://tse3.mm.bing.net/th/id/OIP.fqPPz4wieHpVF4SF0Q7pZAHaHa?cb=iwp2&rs=1&pid=ImgDetMain"
                alt="Footwear"
                roundedCircle
                className="me-2"
                style={imageStyle}
              />
              Footwear<br />
              <small className="text-muted">Delivery Date: 27/05/2025</small>
            </td>
            <td>04621008</td>
            <td>1</td>
            <td>$24.00</td>
          </tr>
        </tbody>
      </Table>

      <Row className="justify-content-end">
        <Col xs={12} md={5} lg={4}>
          <Table borderless className="text-end" style={{ fontSize: "0.95rem" }}>
            <tbody>
              <tr>
                <td>Subtotal:</td>
                <td>$264.00</td>
              </tr>
              <tr>
                <td>VAT (0%):</td>
                <td>$0.00</td>
              </tr>
              <tr>
                <td>Shipping Rate:</td>
                <td>$5.00</td>
              </tr>
              <tr>
                <td><strong>Grand Total:</strong></td>
                <td><strong>$269.00</strong></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      <Row className="mt-4 text-center">
        <Col xs={12} className="d-grid gap-2 d-sm-flex justify-content-sm-center justify-content-md-end">
          <Button variant="outline-primary" className="me-2">
            <FontAwesomeIcon icon={faPrint} className="me-1" style={iconStyle} /> Print Invoice
          </Button>
          <Button variant="outline-success" className="me-2">
            <FontAwesomeIcon icon={faDownload} className="me-1" style={iconStyle} /> Download
          </Button>
          <Button variant="primary">
            <FontAwesomeIcon icon={faFileInvoice} className="me-1" style={iconStyle} /> Create Invoice
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Invoice;
